<template>
	<span class="am-text"
		:class="[
			`am-text--${theme}`,
			`am-text--${type}`,
			{ 'is-dark': dark }
		]"
	>
		<slot></slot>
	</span>
</template>

<script>
export default {
	props: {
		theme: {
			type: String,
			default: 'primary' // primary | secondary
		},
		type: {
			type: String,
			default: 'body' // check the style
		},
		dark: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss">
.am-text{
	display: block;
	color: #99887F;
	b{
		font-weight: 500;
	}

	// Types
	&--title{
		font-family: SanFrancisco;
		font-weight: 500;
		font-size: 54px;
	}
	&--subtitle{
		font-family: Khand;
		font-weight: 400;
		font-size: 30px;
		line-height: 32px;
	}
	&--body{
		font-size: 14px;
		line-height: 16px;
		font-family: Flama;
		font-weight: 400;
		color: #A5A4A6;
	}
	&--placeholder{
		font-family: Flama;
		font-size: 16px;
	}
	&--button{
		font-size: 20px;
		font-family: Khand;
	}
	&--nav{
		font-family: 'Barlow', sans-serif;
		text-transform: uppercase;
		font-size: 18px;
	}
	&--caption{
		font-family: Flama;
		font-size: 12px;
		line-height: 18px;
	}


	// Dark
	&.is-dark{
		color: white;
	}

	@include grid-media($desktop-grid) {
		&--title{
			font-size: 72px;
		}
		&--subtitle{
			font-size: 42px;
			line-height: 40px;
		}
		&--body{
			font-size: 22px;
			line-height: 25px;
		}
		&--nav{
			font-size: 17px;
		}
	}
}
</style>
